<template>
  <b-button
    variant="warning"
    @click="update"
  >
    更新
  </b-button>
</template>

<script>
export default {
  data () {
    return {
      modelName: 'seatingStatus',
    }
  },

  methods: {
    async update () {
      this.$store.dispatch('loading/show')
      const result = await this.$store.dispatch(`${this.modelName}/update`)
      this.$store.dispatch('loading/hide')

      if (result) {
        this.$store.commit(`${this.modelName}/setAttr`, {
          name: 'isEdit',
          value: false
        })

        this.$store.dispatch('toast/show', {
          content: 'ステータスを更新しました。',
          title: 'ステータスの更新'
        })
      }
    }
  }
}
</script>
